import { useState, useEffect } from "react";
import { Container, Box, Text, IconButton, Button, Input,Image, Spinner, Center } from "@chakra-ui/react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
  } from '@chakra-ui/react';
import { useDisclosure } from '@chakra-ui/react';
import { Search2Icon } from '@chakra-ui/icons';
import axios from "axios";
import Navbar from "../../Components/Navbar/Navbar";

const News = () => {

    const { isOpen, onOpen, onClose } = useDisclosure();

    const [query, setQuery] = useState("football");
    const [news, setNews] = useState<any>();
    const [loading, setLoading] = useState(false);

    const GUARDIAN_KEY = process.env.REACT_APP_GUARDIAN_API_KEY;
    const URL = `https://content.guardianapis.com/search?section=football&order-by=newest&use-date=last-modified&show-fields=thumbnail&page-size=20&q=${query}&api-key=${GUARDIAN_KEY}`;

    useEffect(() => {
        fetchNews();
    },[])

    function fetchNews(){
        setLoading(true);
        axios.get(URL)
        .then((result) => {
            // console.log(result);
            setNews(result);
            setLoading(false);
            onClose();
        })
        .catch((error) => {
            console.log(error);
            setLoading(false);
        })
    }

    return(
        <Container maxW={["container.xl","container.sm"]} mt="3" pb="20">

            {/* <Navbar/> */}

            {/* Heading */}
            <Box display="flex">
            <Box>
            <Text fontSize={["2xl"]} fontWeight="bold" color="#ffffff">
                Sizzling News
            </Text>
            <Text color="#ffffff">
                Recent developments.
            </Text>
            </Box>

            {/* Search button */}
            <Box ml="auto">
            <IconButton aria-label='Search database' colorScheme="blue" icon={<Search2Icon />}
            onClick={onOpen} mt="3" />
            </Box>
            </Box>

            {/* News display */}
            <Box mt="2">
            { loading ? 
            // if loading is true show loading
            <Center>
            <Spinner
            thickness='4px'
            speed='0.65s'
            emptyColor='gray.200'
            color='blue.600'
            size='xl'
            mt={["50%","10%"]}
            />
            </Center>
            :
            // if loading is false show news
            <Box>
            {news &&
            <Box mx={["auto", "auto", "4rem"]}>
                {news.data.response && 
                <Box>
                {news.data.response.results.map((data: any) => (

                <Box display="flex" key={data.id} mt="5" w="100%"
                boxShadow="md" bg="#1A1C20" borderRadius="5px">
                    {data.fields.thumbnail &&
                    <Box w={["30%","20%", "25%"]}>
                        <Image
                        boxSize='100px'
                        objectFit='cover'
                        h="100%"
                        src={data.fields.thumbnail}
                        alt='Dan Abramov'
                        borderTopLeftRadius="5px"
                        borderBottomLeftRadius="5px"
                        />
                    </Box>}
                    <Box w={["70%"]} p="3">
                        <Text fontSize="14px" color="#ffffff">
                            {data.webTitle}
                        </Text>
                        <a href={data.webUrl}>
                        <Button colorScheme='blue' size='sm' variant='outline'
                        w="8rem" mt="2">
                            Read more
                        </Button>
                        </a>
                    </Box>
                </Box>

                ))}
                </Box>}
            </Box>}
            </Box>}
            </Box>

            {/* Modal */}
            <Modal size="xs" isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent bg="#1A1C20">
            <ModalHeader color="#ffffff">Search</ModalHeader>
            <ModalBody color="#ffffff">
            <Input onChange={(e) => {setQuery(e.target.value)}} placeholder='Search e.g football, transfer' size='md' />
            </ModalBody>
            <ModalFooter>
                <Button w="full" colorScheme='blue' onClick={fetchNews}>
                Search
                </Button>
            </ModalFooter>
            </ModalContent>
        </Modal>
        </Container>
    );
}

export default News;